// Image with onError fallback — used everywhere we render scraped/inventory photos
// whose source URL (e.g. fundlereach.com/uploads/...) may 404 or be hotlink-blocked.
import { useState } from "react";
import { imageForFormat, imageForCity, IMG } from "@/lib/images";

export default function SmartImage({ src, fallback, format, city, alt = "", className = "", loading = "lazy", ...rest }) {
  const computeFallback = () =>
    fallback ||
    (format ? imageForFormat(format) : null) ||
    (city ? imageForCity(city) : null) ||
    IMG.stockMall1;

  const [current, setCurrent] = useState(src || computeFallback());

  function onError() {
    const fb = computeFallback();
    if (current !== fb) setCurrent(fb);
  }

  return <img src={current} alt={alt} className={className} loading={loading} onError={onError} {...rest} />;
}
